import React, { useEffect, useRef, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, Radio, RadioGroup, FormControlLabel, FormLabel } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatesData } from '../../Store/PHPSlice/States';
import { fetchSingleParty, updatePartyEntry } from '../../Store/PHPSlice/Party';
import { useParams } from 'react-router-dom';



const SalePurchaseEdit = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        partyId: parseInt(Id),
        partyNm: '',
        ph1: '',
        ph2: '',
        emailId: '',
        adrs: '',
        gstType: 'no',
        gst: '',
        pan: '',
        state: '',
        stateNm: '',
        statecd: '',
        partyType: '',
        userId: ''
    });
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const gstInputRef = useRef(null); // Reference for GST input field
    const dispatch = useDispatch();
    const getStates = useSelector((state) => state.StatesData.states || { data: [] });
    const singleParty = useSelector((state) => state.PartyData.singleParty || { data: [] });
    useEffect(() => {
        dispatch(fetchStatesData());
        dispatch(fetchSingleParty(Id));
    }, [dispatch]);

    useEffect(() => {
        if (formData.gstType === 'yes') {
            gstInputRef.current.focus();
        }
    }, [formData.gstType]);

    useEffect(() => {
        if (singleParty.data.length > 0) {
            const item = singleParty.data[0];
            setFormData({
                ...formData,
                partyNm: item.partyNm,
                ph1: item.contact,
                ph2: item.contact2,
                emailId: item.emailId,
                adrs: item.adrs,
                gstType: item.gst_type,
                gst: item.gst,
                pan: item.pan,
                state: item.state_type,
                stateNm: item.stateNm,
                statecd: item.statecd,
                partyType: item.partyType,
            })
        }
    }, [singleParty])

    if (!singleParty) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph1' || name === 'ph2') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph1' && value.length > 10) {
            return;
        }
        if (name === 'ph2' && value.length > 10) {
            return;
        }


        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        if (dropdownType === 'stateNm') {
            const selectedState = getStates.data.find((state) => state.stateName === value);
            const stateCode = selectedState ? selectedState.codes : '';

            setFormData({
                ...formData,
                stateNm: value,
                statecd: stateCode
            });
        } else {
            setFormData({
                ...formData,
                [dropdownType]: value
            });
        }
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        // console.log(formData);
        dispatch(updatePartyEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Party Updated Successful");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });


    };

    const partyType = [
        { label: 'Sale', value: 1 },
        { label: 'Purchase', value: 2 },
        { label: 'Both', value: 3 }
    ];
    return (
        <>
            <div style={{ margin: '6% 1%' }}>
                <h2>Sale & Purchase Party Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>
                                {[
                                    { label: 'Party Name', name: 'partyNm' },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Contact No1', name: 'ph1' },
                                    { label: 'Contact No2', name: 'ph2' },
                                    { label: 'Address', name: 'adrs' },
                                    { label: 'Pan', name: 'pan' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />

                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <FormLabel component="legend">GST Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth error={!!errors.gstType}>
                                                <RadioGroup row name="gstType" value={formData.gstType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="1" control={<Radio />} label="No" />
                                                </RadioGroup>
                                                {errors.gstType && <FormHelperText style={errorStyles}>{errors.gstType}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'GST', name: 'gst' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                        disabled={formData.gstType === 'no'}
                                                        inputRef={gstInputRef}
                                                    />

                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <FormLabel component="legend">State:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth error={!!errors.stateInOut}>
                                                <RadioGroup row name="state" value={formData.state} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Inside" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Outside" />
                                                </RadioGroup>
                                                {errors.stateInOut && <FormHelperText style={errorStyles}>{errors.stateInOut}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="stateNm">State Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="stateNm"
                                                    id="stateNm"
                                                    name="stateNm"
                                                    value={formData.stateNm}
                                                    onChange={(e) => handleDropdownChange(e, 'stateNm')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        getStates.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.stateName}>{item.stateName}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[

                                    { label: 'State Code', name: 'statecd' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel id="partyType">Party Type :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="partyType"
                                                    id="partyType"
                                                    name="partyType"
                                                    value={formData.partyType}
                                                    onChange={(e) => handleDropdownChange(e, 'partyType')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        partyType.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default SalePurchaseEdit;
